import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0.937743992,1492.58261 L1493.49214,0.0244013909 L1919.94003,426.468881 L1776.74461,569.662301 L1776.86455,569.781239 L570.695763,1775.94503 L570.577824,1775.82509 L427.382405,1919.02051 L0.937743992,1492.58261 Z M533.002395,1662.87392 L608.388131,1587.48319 L508.125351,1487.2254 L432.739615,1562.60614 L533.002395,1662.87392 Z M683.773868,1512.10245 L759.158605,1436.71171 L658.895825,1336.45393 L583.511088,1411.83467 L683.773868,1512.10245 Z M834.544341,1361.33097 L909.930078,1285.94024 L734.281562,1110.29172 L658.895825,1185.68246 L834.544341,1361.33097 Z M985.314815,1210.5595 L1060.69755,1135.16877 L960.437772,1034.91098 L885.052035,1110.29172 L985.314815,1210.5595 Z M1136.08829,1059.78803 L1211.46903,984.40229 L1111.21124,884.139511 L1035.82051,959.524248 L1136.08829,1059.78803 Z M1286.85976,909.016554 L1362.2405,833.630817 L1186.59198,657.9833 L1111.21124,733.368037 L1286.85976,909.016554 Z M1437.63123,758.24608 L1513.01197,682.860344 L1412.75419,582.597564 L1337.36346,657.9833 L1437.63123,758.24608 Z M1588.40271,607.474607 L1663.78345,532.08887 L1563.52566,431.826091 L1488.13493,507.211827 L1588.40271,607.474607 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRulerSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRulerSolid, _Component);

  var _super = _createSuper(IconRulerSolid);

  function IconRulerSolid() {
    _classCallCheck(this, IconRulerSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRulerSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRuler",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRulerSolid.displayName = "IconRulerSolid";
  return IconRulerSolid;
}(Component);

IconRulerSolid.glyphName = 'ruler';
IconRulerSolid.variant = 'Solid';
IconRulerSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRulerSolid;
export { IconRulerSolid };